import { useEffect, useRef, useState } from 'react'
import { debounce } from 'ts-debounce'

import { breakpoint } from '@/constant'

const DEBOUNCE_DELAY = 600

export const useMobile = (callback?: (mobile: boolean) => void) => {
	const [mobile, setMobile] = useState(window.innerWidth < breakpoint.lg)
	const debounceMobile = useRef(
		debounce((value) => {
			setMobile(value)
			if (callback) {
				callback(mobile)
			}
		}, DEBOUNCE_DELAY),
	).current

	useEffect(() => {
		setMobile(window.innerWidth < breakpoint.lg)

		const handleResize = () => {
			debounceMobile(window.innerWidth < breakpoint.lg)
		}

		window.addEventListener('resize', handleResize)

		return () => {
			window.removeEventListener('resize', handleResize)
		}
	}, [])

	return {
		mobile,
	}
}
